import type { ReactElement } from 'react';
import type { LinkProps } from '@mui/material';
import { Link } from '@mui/material';

export function AlertLink(props: LinkProps): ReactElement {
  return <Link color="inherit" underline="always" {...props} />;
}
